import type { I18nKeyModifier } from "app/pages/sales-intelligence/modules/leads-search/containers/leads-actions/SaveToListButton/types";
import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search/types";

export const tableActionsI18KeyModifier: Record<LeadsType, I18nKeyModifier> = {
    companies: "add-company",
    websites: "account",
};
